import get from 'lodash/get';

const extractCommunity = community => ({
  communityId: get(community, 'id'),
  communityName: get(community, 'name'),
});
const extractEvent = event => ({
  ...(event.community
    ? extractCommunity(event.community)
    : {}),
  eventId: get(event, 'id'),
  eventName: get(event, 'name'),
  categories: (get(event, 'categories') || []).map(c => c.name),
});
const extractAnnouncement = announcment => ({
  ...(announcment.community
    ? extractCommunity(announcment.community)
    : {}),
  ...(announcment.event
    ? extractEvent(announcment.event)
    : {}),
});
const extractActivity = activity => (activity.event
  ? extractEvent(activity.event)
  : {});
const extractFavor = favor => (favor.event
  ? extractEvent(favor.event)
  : {});
const extractMedium = medium => (medium.event
  ? extractEvent(medium.event)
  : {});
const extractParty = party => (party.event
  ? extractEvent(party.event)
  : {});
const extractInvitation = invitation => (invitation.party
  ? extractParty(invitation.party)
  : {});
const extractProduct = product => ({
  ...(product.event
    ? extractEvent(product.event)
    : {}),
  productId: get(product, 'id'),
  productName: get(product, 'name'),
});
const extractReview = review => (review.product
  ? extractProduct(review.product)
  : {});
const extractComment = comment => {
  if (comment.community) {
    return extractCommunity(comment.community);
  }
  if (comment.event) {
    return extractEvent(comment.event);
  }
  if (comment.medium) {
    return extractMedium(comment.medium);
  }
  if (comment.party) {
    return extractParty(comment.party);
  }
  if (comment.product) {
    return extractProduct(comment.product);
  }
  if (comment.review) {
    return extractReview(comment.review);
  }
  return {};
};

export default ({
  activity, announcment, comment, community, event, favor, invitation, medium,
  party, product, review, viewer,
}) => {
  let fields = {};
  if (activity) {
    fields = extractActivity(activity);
  } else if (announcment) {
    fields = extractAnnouncement(announcment);
  } else if (comment) {
    fields = extractComment(comment);
  } else if (community) {
    fields = extractCommunity(community);
  } else if (event) {
    fields = extractEvent(event);
  } else if (favor) {
    fields = extractFavor(favor);
  } else if (invitation) {
    fields = extractInvitation(invitation);
  } else if (medium) {
    fields = extractMedium(medium);
  } else if (party) {
    fields = extractParty(party);
  } else if (product) {
    fields = extractProduct(product);
  } else if (review) {
    fields = extractReview(review);
  }
  if (viewer) {
    fields.userId = get(viewer, 'person.id');
  }
  return fields;
};
